<template>


  <!-- Copy the content below until next comment -->
  <div class="card card-custom shadow rounded  mr-2 p-2 mb-5">
    <div>

      <div class="p-3 icon-position-card circle h5">
        <b-icon icon="bootstrap-fill" aria-hidden="true" class="h3 m-auto"></b-icon>
      </div>

    </div>
    <div class="card-body mt-4">
      <h4 class="card-title font-weight-bold">
        <slot name="p-1"></slot>
      </h4>
      <b-col sm="12">
        <span class="card-text"><slot name="p-2"></slot> </span>
      </b-col>
    </div>

  </div>
  <!-- Copy until here -->


</template>

<script>
export default {
  name: "C32"
}
</script>

<style scoped>


.card-custom {
  border-radius: 15px;
  height: auto;
  position: relative;
}


.icon-position-card {
  background: var(--primary);
  border-radius: 50%;
  position: absolute;
  margin-top: -29px;
  margin-right: 33px;
}
</style>